import React from 'react';
import { Check, Star, ExternalLink } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { getLocalizedText } from '../../utils/helpers';

export const GoogleRatingsTab = ({ 
  pendingGoogleRatings, 
  pendingGoogleRatingsCount,
  onAction 
}) => {
  // Helper to get rating from either old or new format
  const getRating = (item) => item.google_business_rating?.google_rating || item.google_rating;
  const getReviewsCount = (item) => item.google_business_rating?.google_reviews_count || item.google_reviews_count;
  const getMapsUrl = (item) => item.google_business_rating?.google_maps_url || item.google_maps_url;

  if (pendingGoogleRatingsCount === 0) {
    return (
      <div className="text-center py-12">
        <Check className="h-12 w-12 text-green-500 mx-auto mb-4" />
        <p className="text-gray-500">No hay ratings de Google pendientes</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {pendingGoogleRatings?.teachers?.length > 0 && (
        <div>
          <h3 className="font-semibold mb-4 flex items-center gap-2">
            <Star className="h-5 w-5 text-yellow-500" />
            Profesionales ({pendingGoogleRatings.teachers.length})
          </h3>
          <div className="space-y-2">
            {pendingGoogleRatings.teachers.map(teacher => (
              <div key={teacher.id} className="flex items-center justify-between bg-yellow-50 rounded-lg p-4 border-l-4 border-yellow-400">
                <div className="flex items-center gap-3">
                  <img src={teacher.images?.[0] || teacher.avatar || '/default-avatar.png'} alt="" className="w-10 h-10 rounded-full object-cover" />
                  <div>
                    <p className="font-medium">{teacher.user_name || teacher.name}</p>
                    <div className="flex items-center gap-2 text-sm">
                      <Star className="h-4 w-4 text-yellow-500 fill-yellow-500" />
                      <span>{getRating(teacher)}</span>
                      <span className="text-gray-400">({getReviewsCount(teacher)} reviews)</span>
                      {getMapsUrl(teacher) && (
                        <a href={getMapsUrl(teacher)} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline flex items-center gap-1">
                          <ExternalLink className="h-3 w-3" /> Maps
                        </a>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Button size="sm" className="bg-green-500 hover:bg-green-600" onClick={() => onAction(`/api/admin/verify-google-rating/teacher/${teacher.id}`)}>
                    <Check className="h-4 w-4 mr-1" /> Verificar
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {pendingGoogleRatings?.schools?.length > 0 && (
        <div>
          <h3 className="font-semibold mb-4 flex items-center gap-2">
            <Star className="h-5 w-5 text-yellow-500" />
            Escuelas ({pendingGoogleRatings.schools.length})
          </h3>
          <div className="space-y-2">
            {pendingGoogleRatings.schools.map(school => (
              <div key={school.id} className="flex items-center justify-between bg-yellow-50 rounded-lg p-4 border-l-4 border-yellow-400">
                <div className="flex items-center gap-3">
                  <img src={school.images?.[0] || '/default-school.png'} alt="" className="w-10 h-10 rounded-lg object-cover" />
                  <div>
                    <p className="font-medium">{getLocalizedText(school.name, 'es')}</p>
                    <div className="flex items-center gap-2 text-sm">
                      <Star className="h-4 w-4 text-yellow-500 fill-yellow-500" />
                      <span>{getRating(school)}</span>
                      <span className="text-gray-400">({getReviewsCount(school)} reviews)</span>
                      {getMapsUrl(school) && (
                        <a href={getMapsUrl(school)} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline flex items-center gap-1">
                          <ExternalLink className="h-3 w-3" /> Maps
                        </a>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Button size="sm" className="bg-green-500 hover:bg-green-600" onClick={() => onAction(`/api/admin/verify-google-rating/school/${school.id}`)}>
                    <Check className="h-4 w-4 mr-1" /> Verificar
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
